import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

const ApiService = {
  init () {
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = '/api'
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  get(resource, slug = "") {
    return Vue.axios.get(`${resource}/${slug}`).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  post(resource, params) {
    var formdata = new FormData();
    Object.keys(params).forEach(function(key){
      if(key == 'filter'){
        formdata.append(key, JSON.stringify(params[key]));
      }else{
        formdata.append(key, params[key]);
      }
    });
    return Vue.axios.post(`${resource}`, formdata);
  },

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  delete(resource) {
    return Vue.axios.delete(resource).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  }

}

export default ApiService

export const CatService = {

  get() {
    return ApiService.get("category");
  }
};

export const CommentsService = {
  add(params) {
    
    return ApiService.post("comment/post", params);
  }
};

export const NewspaperService = {
  getinfo(params) {
    return ApiService.post("newspaper/getinfo",params);
  },
  getlist( params) {
    return ApiService.post('newspaper/getlist', params);
  },
  getlast() {
    return ApiService.get("newspaper/getlast");
  }
};

export const NewsService = {
  getinfo( params) {
    return ApiService.post('news/getinfo', params);
  },
  getlist( params) {
    return ApiService.post('news/getlist', params);
  },
};